import React from 'react';
import { Check, ArrowRight, Phone } from 'lucide-react';
import { businessInfo } from '../../data/mock';

export const OfferCard = ({ offer, onBook }) => (
  <article
    id={`offer-${offer.id}`}
    className="group bg-white border border-neutral-200 rounded-sm overflow-hidden shadow-xl shadow-neutral-900/5 flex flex-col scroll-mt-24"
    data-testid={`special-offer-${offer.id}`}
  >
    <div className="relative h-44 sm:h-56 md:h-64 overflow-hidden">
      <img src={offer.image} alt={offer.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      <span className="absolute top-4 left-4 bg-red-600 text-white font-display uppercase tracking-widest text-xs font-bold px-3 py-1.5 rounded-sm">
        Facebook Exclusive
      </span>
    </div>
    <div className="p-5 sm:p-7 md:p-9 flex flex-col flex-1 border-t-4 border-red-600">
      <span className="font-display uppercase tracking-[0.2em] text-xs font-semibold text-red-600">{offer.eyebrow}</span>
      <h2 className="font-display italic uppercase text-3xl md:text-4xl font-extrabold text-neutral-950 mt-1">{offer.title}</h2>
      <div className="flex items-end gap-3 mt-3 mb-2">
        <span className="text-neutral-500 text-sm mb-2">{offer.priceNote}</span>
        <span className="font-display italic font-extrabold text-5xl sm:text-6xl text-red-600 leading-none" data-testid={`special-price-${offer.id}`}>{offer.price}</span>
        {offer.wasPrice && <span className="text-neutral-400 text-2xl line-through mb-1" data-testid={`special-was-${offer.id}`}>{offer.wasPrice}</span>}
      </div>
      <p className="text-neutral-700 mb-6">{offer.tagline}</p>
      <ul className="space-y-2.5 sm:space-y-3 mb-6 sm:mb-8 flex-1" data-testid={`special-includes-${offer.id}`}>
        {offer.includes.map((item) => (
          <li key={item} className="flex items-start gap-3 text-neutral-800 text-[15px] md:text-base leading-snug">
            <span className="mt-0.5 w-5 h-5 rounded-full bg-red-600 flex items-center justify-center shrink-0"><Check className="w-3 h-3 text-white" /></span>
            {item}
          </li>
        ))}
      </ul>
      <button
        type="button"
        onClick={() => onBook(offer)}
        data-testid={`special-book-${offer.id}`}
        className="group/btn w-full inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white font-display uppercase tracking-wider text-lg font-bold py-4 rounded-sm shadow-lg shadow-red-600/25 hover:-translate-y-0.5"
      >
        Book My {offer.title.split(' ').slice(-2).join(' ')}
        <ArrowRight className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform duration-300" />
      </button>
      <a href={`tel:${businessInfo.phone}`} className="mt-1 py-3 inline-flex items-center justify-center gap-2 text-sm text-neutral-600 hover:text-red-600" data-testid={`special-call-${offer.id}`}>
        <Phone className="w-4 h-4 text-red-600" /> Questions? Call or text {businessInfo.phone}
      </a>
    </div>
  </article>
);
